import React, { useState, useRef } from 'react';
import './FitToFlyflow.css';
import SignatureCanvas from 'react-signature-canvas';
import { useLocation } from 'react-router-dom';
import FitToFlyService from '../../../../../services/fitToFly/fitToFly.service'
import { useStore } from "../../../../../Hooks/useStore";
import { API, graphqlOperation, Storage } from "aws-amplify";
    


// import React, { useState, useRef } from 'react';
const Fit2Fly = () => {
    const { rootStore } = useStore();
    const location = useLocation();
    const passengerData = location.state?.passenger;
    const [step, setStep] = useState('intro');
    const sigCanvas = useRef(null);
    //   const [step, setStep] = useState('pre-screening');
    const [uploadErr, setUploadErr] = useState(null);
    const [formData, setFormData] = useState({

      
        // Pre-screening
        recentSurgery: false,
        medicalCondition: true,
        pregnancy: false,
        specialEquipment: true,
        recentHospitalization: false,
        medicalNeeds: true,

        // Medical Assessment
        cardiovascular: '',
        respiratory: '',
        postSurgery: '',
        neurological: '',
        contagious: '',
        doctorNotes: null,

        // Vitals
        oxygen: '',
        heartRate: '',
        bloodPressure: '',
        shortnessBreath: false,
        neurologicalStability: '',

        // Equipment
        supplementalOxygen: false,
        wheelchair: false,
        medicalEscort: false,
        medications: false,

        // Review
        // sigCanvas = {},
        signature: '',
        date: new Date().toISOString().split('T')[0],

        // Status
        clearanceStatus: 'Cleared',

        passengerName: passengerData?.name || '',
        passengerEmail: passengerData?.email || '',
        passengerAge: passengerData?.age || '',
        passengerOrg: passengerData?.orgName || '',
        passengerGender: passengerData?.gender || '',
        passengerContact: passengerData?.contactNumber || '',
    });

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value
        }));
    };

    {/*
    const handleSubmit = (e) => {
        e.preventDefault();
        const signatureData = sigCanvas.current.toDataURL();
        // API call would go here
        const hasMedicalIssues = Object.entries(formData)
            .slice(0, 6)
            .some(([key, val]) => val === true);

        setFormData(prev => ({
            ...prev,
            signature: signatureData,
            // clearanceStatus: hasMedicalIssues ?
            //     (Math.random() > 0.3 ? 'Cleared with conditions' : 'Cleared') :
            //     'Cleared'
        }));
        setStep('status');
    };
    */}

    const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) u8arr[n] = bstr.charCodeAt(n);
        return new File([u8arr], filename, { type: mime });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {

            // Step 1: Check if assessment already exists
            let fitToFlyExistRes = null;
            try {
                fitToFlyExistRes = await FitToFlyService.getAssessmentByPassenger(passengerData.id);
            } catch (checkError) {
                // If API throws 400, it means no assessment exists yet — safe to continue
                if (checkError?.response?.status !== 400) {
                    console.error("Error checking existing assessment:", checkError);
                    rootStore.notificationToastStore.showNotification("Failed to check existing assessment.", true);
                    return; // Stop only if it's another type of error (like 500 or network)
                }
            }

            if (fitToFlyExistRes && fitToFlyExistRes.id) {
                const message = "Assessment for this Passenger is already submitted.";
                rootStore.notificationToastStore.showNotification(message, true);
                return; // Stop execution here
            }

            console.log("Proceeding to submit assessment...");

            try {
                console.log("🖋️ Preparing signature and documents...");
                
                let doctorNoteUrl = null;
                let signatureUrl = null;

                if (formData.doctorNotes) {
                    rootStore.notificationToastStore.showNotification("Uploading medical document...", false);
                    doctorNoteUrl = await uploadFile(formData.doctorNotes, passengerData?.id || formData.passengerName);
                    console.log("📄 Doctor note uploaded:", doctorNoteUrl);
                }

                // Convert and upload signature to S3
                if(sigCanvas.current){
                    const signatureData = sigCanvas.current.toDataURL();
                    if (signatureData) {
                        const signatureFile = dataURLtoFile(signatureData, `${passengerData.id}_signature.png`);
                        rootStore.notificationToastStore.showNotification("Uploading signature...", false);
                        signatureUrl = await uploadFile(signatureFile, passengerData?.id || formData.passengerName);
                        console.log("✍️ Signature uploaded:", signatureUrl);
                    }
                }

                const payload = {
                    recentSurgery: formData.recentSurgery,
                    medicalCondition: formData.medicalCondition,
                    pregnancy: formData.pregnancy,
                    specialMedicalEquipment: formData.specialEquipment,
                    hospitalizationInLast30Days: formData.recentHospitalization,
                    needForOxygenOrEscort: formData.medicalNeeds,
                    cardiovascularConditions: formData.cardiovascular,
                    respiratoryConditions: formData.respiratory,
                    postSurgeryInformation: formData.postSurgery,
                    neurologicalConcerns: formData.neurological,
                    contagiousDiseases: formData.contagious,
                    oxygenSaturation: formData.oxygen ? `${formData.oxygen}%` : "",
                    heartRate: formData.heartRate ? `${formData.heartRate} bpm` : "",
                    bloodPressure: formData.bloodPressure ? `${formData.bloodPressure} mmHg` : "",
                    neurologicalStability: formData.neurologicalStability,
                    shortnessOfBreath: formData.shortnessBreath,
                    requireSupplementalOxygen: formData.supplementalOxygen,
                    needForWheelchairOrStretcher: formData.wheelchair,
                    needForMedicalEscort: formData.medicalEscort,
                    medicationsInFlight: formData.medications,
                    doctorNotesFilePath: doctorNoteUrl,
                    signatureUrl,
                    date: formData.date,
                };

                rootStore.notificationToastStore.showNotification("Submitting Fit-to-Fly assessment...", false);
                await FitToFlyService.submitAssessment(passengerData.id, payload);
                rootStore.notificationToastStore.showNotification("Assessment submitted successfully!", false, 3000);

                setStep("status");
            } catch (error) {
                console.error("Error submitting Fit-to-Fly:", error);
                // Step 4: Handle specific API error message
                const apiMessage = error?.response?.data?.errorMessage;
                rootStore.notificationToastStore.showNotification(apiMessage, true);
            }
        } catch (error) {
            console.error("❌ Unexpected error in handleSubmit:", error);
            rootStore.notificationToastStore.showNotification("An unexpected error occurred. Please try again.", true);
        }
    };



    const uploadFile = async (file, roomId) => {
        // const imageExtention = file.name.split(".").pop();
        // const now = Date.now();
        const filePath = `FitToFlyForms/${roomId}/${file.name}`;
        const currentUrl = window.location.href;
        let region = 'us-east-2'; // Default region
        let bucket = 'skali-report';
      
        // Check if the URL contains "localhost" or "sbx" to decide region
        if (currentUrl.includes('localhost') || currentUrl.includes('sbx')) {
          region = 'us-west-1';  // Set region to us-west-1 for localhost or sbx
          bucket = 'sbx-skali-report'; 
        }
    
    
        try {
          // Upload the file to S3
          await Storage.put(filePath, file, {
            bucket: bucket,
            region: region,
            contentType: file.type,
            progressCallback: (progress) => {
              console.log('Upload progress:', progress);
            },
          });
          console.log('File uploaded successfully');
    
          // Retrieve the public URL of the uploaded file
          const fileUrl = await Storage.get(filePath, {
            
            bucket: bucket,
            region: region,
            level: 'public', // Adjust access level if needed
            expires: 604799
          });
          const messageContent = fileUrl.split('?')[0];
          console.log('File URL:', fileUrl);
          return messageContent;
        } catch (error) {
          console.error('Error uploading file:', error);
          setUploadErr(error);
          throw error;
        }
    };

    // Pre-screening Step

    // Intro Step - Add this new step condition
    if (step === 'intro') {
        return (
            <div className="fit2fly-container">
                <div className="intro-card">
                    <div className="intro-header">
                        <h1>Fit-to-Fly Health Assessment</h1>
                        <div className="airplane-icon">✈️</div>
                    </div>

                    <div className="intro-content">
                        <p>This assessment will help determine if you're medically cleared based on:</p>
                        <ul className="feature-list">
                            <li>Current health status</li>
                            <li>Medical history</li>
                            <li>Vital signs</li>
                            <li>Special Equipment & Assistance</li>
                        </ul>

                    </div>

                    <button
                        className="start-button"
                        onClick={() => setStep('passenger-details')}
                    >
                        Start
                    </button>
                </div>
            </div>
        );
    }


    if (step === 'passenger-details') {
        return (
          <div className="fit2fly-container">
            <div className="flow-card">
              <h2>Passenger Information</h2>
              <form className="passenger-form">
                <div className="form-group">
                  <label htmlFor="passengerName">Full Name</label>
                  <input
                    type="text"
                    id="passengerName"
                    value={formData.passengerName}
                    readOnly
                    className="readonly-input"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="passengerEmail">Email Address</label>
                  <input
                    type="email"
                    id="passengerEmail"
                    value={formData.passengerEmail}
                    readOnly
                    className="readonly-input"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="passengerAge">Age</label>
                  <input
                    type="number"
                    id="passengerAge"
                    value={formData.passengerAge}
                    readOnly
                    className="readonly-input"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="passengerOrg">Organization</label>
                  <input
                    type="text"
                    id="passengerOrg"
                    value={formData.passengerOrg}
                    readOnly
                    className="readonly-input"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="passengerGender">Gender</label>
                  <input
                    type="text"
                    id="passengerGender"
                    value={formData.passengerGender}
                    readOnly
                    className="readonly-input"
                  />
                </div>
                
                {formData.passengerContact && (
                  <div className="form-group">
                    <label htmlFor="passengerContact">Contact Number</label>
                    <input
                      type="tel"
                      id="passengerContact"
                      value={formData.passengerContact}
                      readOnly
                      className="readonly-input"
                    />
                  </div>
                )}
              </form>
              
              <div className="nav-buttons">
                <button 
                  className="secondary-btn"
                  onClick={() => setStep('intro')}
                >
                  Back
                </button>
                <button 
                  className="primary-btn"
                  onClick={() => setStep('pre-screening')}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        );
      }


    if (step === 'pre-screening') {
        const allNo = !Object.values(formData).slice(0, 6).some(val => val);

        return (
            <div className="fit2fly-container">
                <div className="flow-card">
                    <h2>Pre-Screening Questions</h2>
                    <p>Answer these health questions to determine if you're fit to fly:</p>

                    <div className="yes-no-grid">
                        {[
                            'Recent surgery?',
                            'Medical condition?',
                            'Pregnancy?',
                            'Special medical equipment?',
                            'Hospitalization in last 30 days?',
                            'Need for oxygen, stretcher, or escort?'
                        ].map((question, i) => (
                            <div key={i} className="question-row">
                                <label>{question}</label>
                                <div className="toggle-group">
                                    <button
                                        type="button"
                                        className={`toggle-btn ${formData[Object.keys(formData)[i]] ? '' : 'active'}`}
                                        onClick={() => handleChange({
                                            target: {
                                                name: Object.keys(formData)[i],
                                                type: 'checkbox',
                                                checked: false
                                            }
                                        })}
                                    >
                                        No
                                    </button>
                                    <button
                                        type="button"
                                        className={`toggle-btn ${formData[Object.keys(formData)[i]] ? 'active' : ''}`}
                                        onClick={() => handleChange({
                                            target: {
                                                name: Object.keys(formData)[i],
                                                type: 'checkbox',
                                                checked: true
                                            }
                                        })}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="nav-buttons">
                        <button
                            className="secondary-btn"
                            onClick={() => setStep('passenger-details')} // Replace 'previous-step' with the actual previous step name
                        >
                            Back
                        </button>
                        {allNo ? (
                            <>
                                <button
                                    className="primary-btn"
                                    onClick={handleSubmit}
                                >
                                    Confirm Fit to Fly
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    className="primary-btn"
                                    onClick={() => setStep('medical-assessment')}
                                >
                                    Continue Medical Assessment
                                </button>
                            </>
                        )}

                        {/* Back Button */}

                    </div>

                </div>
            </div>
        );
    }

    // Medical Assessment Step
    if (step === 'medical-assessment') {
        return (
            <div className="fit2fly-container">
                <div className="flow-card">
                    <h2>Medical Risk Assessment</h2>
                    <p>Please provide details about your medical conditions:</p>

                    <div className="accordion">
                        {[
                            { title: 'Cardiovascular Conditions', name: 'cardiovascular' },
                            { title: 'Respiratory Conditions', name: 'respiratory' },
                            { title: 'Post-Surgery Information', name: 'postSurgery' },
                            { title: 'Neurological Concerns', name: 'neurological' },
                            { title: 'Contagious Diseases', name: 'contagious' }
                        ].map((section, i) => (
                            <div key={i} className="accordion-item">
                                <input type="checkbox" id={`accordion-${i}`} />
                                <label htmlFor={`accordion-${i}`} className="accordion-header">
                                    {section.title}
                                    <span className="arrow"></span>
                                </label>
                                <div className="accordion-content">
                                    <textarea
                                        name={section.name}
                                        value={formData[section.name]}
                                        onChange={handleChange}
                                        placeholder={`Describe your ${section.title.toLowerCase()}`}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="file-upload">
                        <label>Doctor's Notes/Medical Documents</label>
                        <input
                            type="file"
                            name="doctorNotes"
                            onChange={(e) => {
                            const file = e.target.files[0];
                            const errorElement = document.getElementById("file-error");
                            
                            // Reset error
                            if (errorElement) errorElement.textContent = "";
                            
                            if (file) {
                                // Validate file type
                                const allowedTypes = [".pdf", ".doc", ".docx", ".jpg", ".png"];
                                const fileExt = file.name.split('.').pop().toLowerCase();
                                
                                if (!allowedTypes.includes(`.${fileExt}`)) {
                                if (errorElement) errorElement.textContent = "Error: Only PDF, DOC, DOCX, JPG, and PNG files are supported.";
                                e.target.value = ""; // Clear invalid file
                                return;
                                }
                                
                                // Validate file size (10MB max)
                                if (file.size > 10 * 1024 * 1024) {
                                if (errorElement) errorElement.textContent = "Error: File size exceeds 10MB. Please upload a smaller file.";
                                e.target.value = ""; // Clear oversized file
                                return;
                                }
                                
                                // If valid, proceed with your handleChange logic
                                handleChange(e); // Your existing handler
                            }
                            }}
                            accept=".pdf,.doc,.docx,.jpg,.png"
                        />
                        <p id="file-error" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{uploadErr}</p>
                    </div>

                    <div className="nav-buttons">
                        <button
                            className="secondary-btn"
                            onClick={() => setStep('pre-screening')}
                        >
                            Back
                        </button>
                        <button
                            className="primary-btn"
                            onClick={() => setStep('vitals')}
                        >
                            Continue to Vitals
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Vitals Step (Optional)
    if (step === 'vitals') {
        return (
            <div className="fit2fly-container">
                <div className="flow-card">
                    <h2>Vital Signs Entry</h2>
                    <p className="optional-note">This section is optional but recommended</p>

                    <div className="vitals-grid">
                        <div className="input-group">
                            <label>Oxygen Saturation (SpO₂)</label>
                            <input
                                type="number"
                                name="oxygen"
                                value={formData.oxygen}
                                onChange={handleChange}
                                min="70"
                                max="100"
                            />
                            <span className="unit">%</span>
                        </div>

                        <div className="input-group">
                            <label>Heart Rate</label>
                            <input
                                type="number"
                                name="heartRate"
                                value={formData.heartRate}
                                onChange={handleChange}
                                min="30"
                                max="200"
                            />
                            <span className="unit">bpm</span>
                        </div>

                        <div className="input-group">
                            <label>Blood Pressure</label>
                            <input
                                type="text"
                                name="bloodPressure"
                                value={formData.bloodPressure}
                                onChange={handleChange}
                                placeholder="120/80"
                            />
                            <span className="unit">mmHg</span>
                        </div>

                        <div className="input-group">
                            <label>Neurological Stability</label>
                            <select
                                name="neurologicalStability"
                                value={formData.neurologicalStability}
                                onChange={handleChange}
                            >
                                <option value="">Select status</option>
                                <option value="Normal">Normal</option>
                                <option value="Mild impairment">Mild impairment</option>
                                <option value="Severe impairment">Severe impairment</option>
                            </select>
                        </div>

                        <div className="checkbox-group">
                            <input
                                type="checkbox"
                                id="shortnessBreath"
                                name="shortnessBreath"
                                checked={formData.shortnessBreath}
                                onChange={handleChange}
                            />
                            <label htmlFor="shortnessBreath">Experiencing shortness of breath?</label>
                        </div>


                    </div>

                    <div className="nav-buttons">
                        <button
                            className="secondary-btn"
                            onClick={() => setStep('medical-assessment')}
                        >
                            Back
                        </button>
                        <button
                            className="primary-btn"
                            onClick={() => setStep('equipment')}
                        >
                            Continue to Equipment Needs
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Equipment Step
    if (step === 'equipment') {
        return (
            <div className="fit2fly-container">
                <div className="flow-card">
                    <h2>Equipment & In-Flight Needs</h2>

                    <div className="equipment-checklist">
                        {[
                            { label: 'Require supplemental oxygen?', name: 'supplementalOxygen' },
                            { label: 'Need for wheelchair/stretcher?', name: 'wheelchair' },
                            { label: 'Need for medical escort?', name: 'medicalEscort' },
                            { label: 'Medications in-flight?', name: 'medications' }
                        ].map((item, i) => (
                            <div key={i} className="checkbox-group">
                                <input
                                    type="checkbox"
                                    id={item.name}
                                    name={item.name}
                                    checked={formData[item.name]}
                                    onChange={handleChange}
                                />
                                <label htmlFor={item.name}>{item.label}</label>
                            </div>
                        ))}
                    </div>

                    <div className="nav-buttons">
                        <button
                            className="secondary-btn"
                            onClick={() => setStep('vitals')}
                        >
                            Back
                        </button>
                        <button
                            className="primary-btn"
                            onClick={() => setStep('review')}
                        >
                            Review & Submit
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Review Step
    if (step === 'review') {
        return (
            <div className="fit2fly-container">
                <div className="flow-card">
                    <h2>Final Review & Submit</h2>

                    <div className="review-section">
                        <h3>Pre-Screening</h3>
                        <ul>
                            {[
                                'Recent surgery',
                                'Medical condition',
                                'Pregnancy',
                                'Special medical equipment',
                                'Recent hospitalization',
                                'Medical needs'
                            ].map((label, i) => (
                                <li key={i}>
                                    {label}: {formData[Object.keys(formData)[i]] ? 'Yes' : 'No'}
                                    <button
                                        className="edit-btn"
                                        onClick={() => setStep('pre-screening')}
                                    >
                                        Edit
                                    </button>
                                </li>
                            ))}
                        </ul>

                        <h3>Medical Assessment</h3>
                        {[
                            'cardiovascular',
                            'respiratory',
                            'postSurgery',
                            'neurological',
                            'contagious'
                        ].map((field, i) => (
                            formData[field] && (
                                <div key={i} className="medical-note">
                                    <strong>{field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:</strong>
                                    <p>{formData[field]}</p>
                                    <button
                                        className="edit-btn"
                                        onClick={() => setStep('medical-assessment')}
                                    >
                                        Edit
                                    </button>
                                </div>
                            )
                        ))}

                        <h3>Vital Signs</h3>
                        <ul>
                            {formData.oxygen && <li>Oxygen: {formData.oxygen}%</li>}
                            {formData.heartRate && <li>Heart Rate: {formData.heartRate} bpm</li>}
                            {formData.bloodPressure && <li>Blood Pressure: {formData.bloodPressure} mmHg</li>}
                            <li>Shortness of breath: {formData.shortnessBreath ? 'Yes' : 'No'}</li>
                            {formData.neurologicalStability && <li>Neurological: {formData.neurologicalStability}</li>}
                            <button
                                className="edit-btn"
                                onClick={() => setStep('vitals')}
                            >
                                Edit
                            </button>
                        </ul>

                        <h3>Equipment Needs</h3>
                        <ul>
                            {[
                                'supplementalOxygen',
                                'wheelchair',
                                'medicalEscort',
                                'medications'
                            ].map((field, i) => (
                                <li key={i}>
                                    {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
                                    {formData[field] ? 'Yes' : 'No'}
                                    <button
                                        className="edit-btn"
                                        onClick={() => setStep('equipment')}
                                    >
                                        Edit
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="signature-section">
                        <div className="signature-container">
                            <label>Signature</label>
                            <div className="signature-wrapper">
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{
                                        width: 500,
                                        height: 200,
                                        className: 'signature-canvas',
                                    }}
                                    ref={sigCanvas}
                                />
                            </div>
                            <div className="signature-actions">
                                <button
                                    type="button"
                                    className="clear-btn"
                                    onClick={() => sigCanvas.current.clear()}
                                >
                                    Clear Signature
                                </button>
                            </div>
                            <input
                                type="hidden"
                                name="signature"
                                value={sigCanvas.current ? sigCanvas.current.toDataURL() : ''}
                            />
                        </div>
                        
                    </div>

                    <div className="date-display">
                            <label>Date</label>
                            <p>{formData.date}</p>
                        </div>

                    <button
                        className="primary-btn submit-btn"
                        onClick={handleSubmit}
                        // disabled={!formData.signature}
                    >
                        Submit for Clearance
                    </button>
                </div>
            </div>
        );
    }

    // Status Step
    if (step === 'status') {
        const statusConfig = {
            'Cleared': { color: '#2ecc71', icon: '✓' },
            'Cleared with conditions': { color: '#f39c12', icon: '!' },
            'Denied': { color: '#e74c3c', icon: '✗' }
        };

        return (
            <div className="fit2fly-container">
                <div className="flow-card status-card">
                    <div
                        className="status-badge"
                        style={{ backgroundColor: statusConfig[formData.clearanceStatus].color }}
                    >
                        {statusConfig[formData.clearanceStatus].icon}
                    </div>

                    {/* <h2>Fit to Fly Status: {formData.clearanceStatus}</h2> */}

                    {formData.clearanceStatus === 'Cleared' && (
                        <h3>Your application has been submitted for review.</h3>
                    )}

                    {/* {formData.clearanceStatus === 'Cleared' && (
                        <>
                            <p>You've been cleared with the following conditions:</p>
                            <ul className="conditions-list">
                                <li>Medical escort may be required</li>
                                <li>Supplemental oxygen needed during flight</li>
                                <li>Special seating arrangements</li>
                            </ul>
                        </>
                    )} */}

                    {/* {formData.clearanceStatus === 'Denied' && (
                        <p>Based on your medical assessment, we cannot clear you at this time. </p>
                    )} */}

                    {/* <div className="status-actions"> */}
                        {/* {formData.clearanceStatus !== 'Denied' && (
                            <button className="download-btn">
                                Download Fit to Fly Certificate
                            </button>
                        )} */}

                        {/* <button
                            className="primary-btn"
                            onClick={() => {
                                if (sigCanvas.current) sigCanvas.current.clear();
                                setStep('pre-screening');
                                setFormData({
                                    // Reset form but keep some defaults
                                    ...formData,
                                    recentSurgery: false,
                                    medicalCondition: false,
                                    pregnancy: false,
                                    specialEquipment: false,
                                    recentHospitalization: false,
                                    medicalNeeds: false,
                                    date: new Date().toISOString().split('T')[0]
                                });
                            }}
                        >
                            Start New Assessment
                        </button> */}
                    {/* </div> */}
                </div>
            </div>
        );
    }

    return null;
};

export default Fit2Fly;